
<ng-container *ngIf="!showForgotPass">
  <h3 class="title">
    {{ 'END_CONS_SIGN_IN.TITLE' | translate }}
    <p class="description">
      {{ 'END_CONS_SIGN_IN.DESCRIPTION' | translate }}
      <span (click)="toRegister()">{{ 'END_CONS_SIGN_IN.REGISTER_LINK' | translate }}</span>
      {{ 'END_CONS_SIGN_IN.REGISTER_CONTINUATION' | translate }}
    </p>
  </h3>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <!-- Email -->
    <div class="form-group">
      <label for="email">{{ 'END_CONS_SIGN_IN.EMAIL' | translate }} <span class="req">*</span></label>
      <input id="email" type="email" formControlName="email" class="form-control" />
      <div *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
        <small *ngIf="form.get('email')?.errors?.['required']" class="text-danger">
          {{ 'END_CONS_SIGN_IN.ERRORS.EMAIL_REQUIRED' | translate }}
        </small>
        <small *ngIf="form.get('email')?.errors?.['email']" class="text-danger">
          {{ 'END_CONS_SIGN_IN.ERRORS.EMAIL_INVALID' | translate }}
        </small>
      </div>
    </div>

    <!-- Password -->
    <div class="form-group mt-2">
      <label for="password">{{ 'END_CONS_SIGN_IN.PASSWORD' | translate }} <span class="req">*</span></label>
      <input id="password" class="form-control"
             formControlName="password" [type]="showPassword ? 'text' : 'password'"/>
      <i class="icon password-icon"
         [ngClass]="{'icon-eye': showPassword, 'icon-eye-closed': !showPassword}"
         (click)="togglePasswordVisibility()"></i>
      <div *ngIf="form.get('password')?.touched && form.get('password')?.invalid">
        <small *ngIf="form.get('password')?.errors?.['required']" class="text-danger">
          {{ 'END_CONS_SIGN_IN.ERRORS.PASSWORD_REQUIRED' | translate }}
        </small>
      </div>
    </div>
    <small *ngIf="error" class="text-danger">
      {{ 'END_CONS_SIGN_IN.ERRORS.GENERIC' | translate }}
    </small>

    <p class="forgot-link mt-2" (click)="toggleForgotPassword()">
      {{ 'END_CONS_SIGN_IN.FORGOT_PASSWORD' | translate }}
    </p>

    <!-- Submit Button -->
    <button type="submit" class="btn btn-primary with-loader" [disabled]="!form.valid">
      {{ 'END_CONS_SIGN_IN.BUTTON' | translate }}
      <span class="loader" *ngIf="loading"></span>
    </button>
  </form>
</ng-container>

<app-forgot-password *ngIf="showForgotPass"></app-forgot-password>
